import { SessionStorageKey } from '@shared/types';

export const getErrorsCount = () =>
  Number(
    sessionStorage.getItem(SessionStorageKey.MODULE_LOAD_ERROR_COUNT) || 0,
  );

export const setErrorsCount = (count: number) =>
  sessionStorage.setItem(
    SessionStorageKey.MODULE_LOAD_ERROR_COUNT,
    String(count),
  );
